import Vue from 'vue';
import VueRouter from 'vue-router';
import Routes from './routes.js';
import Store from '../store';

Vue.use(VueRouter);

function parseId(route) {
	return {
		id: parseInt(route.params.id, 10)
	};
}

const router = new VueRouter({
	mode: 'hash',
	routes: [
		{
			path: Routes.admin.namespace,
			component: () => import('../components/layout/AdministrationLayout.vue'),
			meta: {
				authenticated: true
			},
			redirect: `${Routes.admin.namespace}/${Routes.admin.home.dashboardRoute.path}`,
			children: [
				{
					...Routes.admin.home.dashboardRoute,
					component: () => import('../pages/admin/home/Dashboard.vue')
				},
				{
					...Routes.admin.user.indexRoute,
					component: () => import('../pages/admin/user/UserIndex.vue')
				},
				{
					...Routes.admin.user.createRoute,
					component: () => import('../pages/admin/user/UserCreate.vue')
				},
				{
					...Routes.admin.user.editRoute,
					component: () => import('../pages/admin/user/UserUpdate.vue'),
					props: parseId
				},
				{
					...Routes.admin.sortition.createRoute,
					component: () =>
						import('../pages/admin/sortition/SortitionCreate.vue')
				},
				{
					...Routes.admin.sortition.editRoute,
					component: () =>
						import('../pages/admin/sortition/SortitionUpdate.vue'),
					props: parseId
				},
				{
					...Routes.admin.sortition.indexRoute,
					component: () => import('../pages/admin/sortition/SortitionIndex.vue')
				},
				{
					...Routes.admin.sortitionDisplay.createRoute,
					component: () =>
						import('../pages/admin/SortitionDisplay/SortitionDisplayCreate.vue')
				},
				{
					...Routes.admin.sortitionDisplay.editRoute,
					component: () =>
						import('../pages/admin/SortitionDisplay/SortitionUpdate.vue'),
					props: parseId
				},
				{
					...Routes.admin.sortitionDisplay.indexRoute,
					component: () =>
						import('../pages/admin/SortitionDisplay/SortitionDisplayIndex.vue')
				},
				{
					...Routes.admin.resultApiUser.indexRoute,
					component: () =>
						import('../pages/admin/resultApiUser/ResultApiUserIndex.vue')
				},
				{
					...Routes.admin.resultApiUser.createRoute,
					component: () =>
						import('../pages/admin/resultApiUser/ResultApiUserCreate.vue')
				},
				{
					...Routes.admin.resultApiUser.editRoute,
					component: () =>
						import('../pages/admin/resultApiUser/ResultApiUserUpdate.vue'),
					props: parseId
				},
				{
					...Routes.admin.lottery.createRoute,
					component: () => import('../pages/admin/lottery/LotteryCreate.vue')
				},
				{
					...Routes.admin.lottery.editRoute,
					component: () => import('../pages/admin/lottery/LotteryUpdate.vue'),
					props: parseId
				},
				{
					...Routes.admin.lottery.indexRoute,
					component: () => import('../pages/admin/lottery/LotteryIndex.vue')
				},
				{
					...Routes.admin.result.indexRoute,
					component: () => import('../pages/admin/result/ResultIndex.vue')
				},
				{
					...Routes.admin.profit.indexRoute,
					component: () => import('../pages/admin/profit/ProfitIndex.vue')
				},
				{
					...Routes.admin.prize.editRoute,
					component: () => import('../pages/admin/prize/PrizeEdit.vue')
				},
				{
					...Routes.admin.server.indexRoute,
					component: () => import('../pages/admin/server/ServerIndex.vue')
				},
				{
					...Routes.admin.actionLog.indexRoute,
					component: () => import('../pages/admin/actionLog/ActionLogIndex.vue')
				}
			]
		},
		{
			path: '/',
			redirect: Routes.session.createRoute.path
		},
		{
			...Routes.session.createRoute,
			component: () => import('../pages/session/SessionCreate.vue')
		},
		{
			...Routes.others.notFoundRoute,
			component: () => import('../components/NotFoundPage.vue')
		},
		{
			path: '*',
			redirect: Routes.others.notFoundRoute.path
		}
	],
	linkActiveClass: 'active'
});

router.beforeEach((to, from, next) => {
	if (to.matched.some(route => route.meta.authenticated)) {
		if (Store.getters.authenticated) {
			return next();
		}

		return next({ name: Routes.session.createRoute.name });
	}

	return next();
});

export default router;
